import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { store } from "./redux/store";
import { Provider } from "react-redux";
import { HashRouter } from "react-router-dom";

const queryParams = new URLSearchParams(window.location.search);
const id = queryParams.get('id');
//const id = "MP277";
//console.log(id);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HashRouter>
    <Provider store={store}>
      <App id={id} />
    </Provider>
  </HashRouter>
);
